import session from '../../app/session'

export const deletePermission = (row) => {
  return !!row && !!row.is_shared ? session.hasAdminPermission() : session.hasClientUserPermission();
};

export const duplicatePermission = (row) => {
  return (!!row && !!row.id) ? session.hasClientUserPermission() : false;
};

export const editPermission = (row) => {
  return (!!row && !!row.id) ? session.hasClientUserPermission() : false;
};
